/**
 * @file コンポーネント：フル動画ページ関連症例 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledSection = styled.aside`
    margin: 0 auto 16px;
    padding: 0 16px;
`;

export const StyledSectionContents = styled.div`
    display: none;
    padding-top: 16px;

    &.is-open {
        display: block;
    }

    > ol {
        ${mediaQuery.sp(`
            width: 195px;
        `)};

        ${mediaQuery.spWide(`
            width: 195px;
        `)};

        ${mediaQuery.tablet(`
            width: 404px;
        `)};

        ${mediaQuery.pc(`
            width: 404px;
        `)};

        ${mediaQuery.pcWide(`
            width: 822px;
        `)};

        > li {
            width: 195px;
            margin-right: 14px;
        }
    }
`;

export const StyledSectionHeader = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 36px;
`;

export const StyledSectionHeaderButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 36px;
    height: 36px;
    margin: auto 0;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 20px;
    line-height: 36px;
    text-align: center;
`;

export const StyledSectionHeaderText = styled.h2`
    color: #ffffff;
    font-weight: normal;
    font-size: 16px;
    line-height: 36px;
`;
